import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LABSEGMENT,
  DELETE_LABSEGMENT,
  GET_LABSEGMENTS,
  UPDATE_LABSEGMENT,
  UPDATE_LABSEGMENT_STATUS
} from "./actionTypes";

import {
  addLabSegmentFail,
  addLabSegmentSuccess,
  deleteLabSegmentFail,
  deleteLabSegmentSuccess,
  getLabSegmentsFail,
  getLabSegmentsSuccess,
  setState,
  updateLabSegmentFail,
  updateLabSegmentSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labSegments, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabSegments({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labSegments, params.toString());
    yield put(setState(false));
    yield put(getLabSegmentsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabSegmentsFail(error));
  }
}

function* updateLabSegment({ payload: labSegmentObj }) {
  try {
    const { id, ...rest } = labSegmentObj;
    yield call(patchApiCall, `${labSegments}/${id}`, rest);
    const response = yield call(getTable, `${labSegments}/${labSegmentObj.id}`);
    yield put(updateLabSegmentSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    toast.error('Error al actualizar el registro');
    yield put(updateLabSegmentFail(error));
  }
}

function* updateLabSegmentStatus({ payload: labSegmentObj }) {
  try {
    const { id } = labSegmentObj;
    yield call(patchApiCall, `${labSegments}/${updateStatus}/${id}`, { recordStatus: labSegmentObj.recordStatus });
    const response = yield call(getTable, `${labSegments}/${labSegmentObj.id}`);
    yield put(updateLabSegmentSuccess(response));
  } catch (error) {
    yield put(updateLabSegmentFail(error));
  }
}

function* deleteLabSegment({ payload: labSegmentObj }) {
  try {
    yield call(deleteApiCall, `${labSegments}/${labSegmentObj.id}`);
    yield put(deleteLabSegmentSuccess(labSegmentObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLabSegmentFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLabSegment({ payload: labSegment }) {
  try {
    const response = yield call(postApiCall, labSegments, labSegment);
    yield put(addLabSegmentSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addLabSegmentFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* labSegmentsSaga() {
  yield takeEvery(GET_LABSEGMENTS, fetchLabSegments);
  yield takeEvery(ADD_NEW_LABSEGMENT, postingLabSegment);
  yield takeEvery(UPDATE_LABSEGMENT, updateLabSegment);
  yield takeEvery(UPDATE_LABSEGMENT_STATUS, updateLabSegmentStatus);
  yield takeEvery(DELETE_LABSEGMENT, deleteLabSegment);
}

export default labSegmentsSaga;
